import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { csuiteApi, csuiteAuth } from "../lib/csuiteApi";

const Ctx = createContext(null);

export function CSuiteAuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null = unknown, false = logged out, object = logged in
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkSession = useCallback(async () => {
    if (!csuiteAuth.getToken()) { setUser(false); setOrg(null); setLoading(false); return; }
    try {
      const r = await csuiteApi.me();
      setUser(r.user);
      setOrg(r.org || null);
    } catch {
      csuiteAuth.setToken("");
      setUser(false);
      setOrg(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkSession(); }, [checkSession]);

  const login = async (email, password) => {
    const r = await csuiteApi.login(email, password);
    setUser(r.user);
    // Fetch fresh /me so we get org info + role gate settings.
    try { const me = await csuiteApi.me(); setOrg(me.org || null); } catch { /* ignore */ }
    return r;
  };

  const verify = async (email, code) => {
    const r = await csuiteApi.verifyCode(email, code);
    setUser(r.user);
    try { const me = await csuiteApi.me(); setOrg(me.org || null); } catch { /* ignore */ }
    return r;
  };

  const logout = async () => {
    try { await csuiteApi.logout(); } catch { /* ignore */ }
    csuiteAuth.setToken("");
    setUser(false);
    setOrg(null);
  };

  return (
    <Ctx.Provider value={{ user, org, loading, login, verify, logout, refresh: checkSession }}>
      {children}
    </Ctx.Provider>
  );
}

export function useCSuiteAuth() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useCSuiteAuth must be used inside CSuiteAuthProvider");
  return v;
}
